import { useState } from 'react';
import type { Username } from '@travel-planner/shared';
import { useLogin } from './useAuth';

const USERS: { value: Username; label: string }[] = [
  { value: 'joel', label: 'Joel' },
  { value: 'lea', label: 'Lea' },
];

function errorMessage(code?: string): string {
  switch (code) {
    case 'invalid_credentials':
      return 'Wrong username or password.';
    case 'locked':
      return 'Too many attempts. Try again in a few minutes.';
    default:
      return 'Login failed. Please try again.';
  }
}

export function LoginForm() {
  const [username, setUsername] = useState<Username>('joel');
  const [password, setPassword] = useState('');
  const login = useLogin();

  return (
    <main
      className="d-flex flex-column justify-content-center align-items-center px-3"
      style={{ minHeight: '100vh' }}
    >
      <div className="card w-100" style={{ maxWidth: 380 }}>
        <div className="card-body p-4">
          <h1 className="h3 text-center mb-1 d-flex justify-content-center align-items-center gap-2">
            <span aria-hidden>✈️</span> Travel Planner
          </h1>
          <p className="text-secondary text-center small mb-4">Plan your next trip together.</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              login.mutate({ username, password });
            }}
          >
            <div className="mb-3">
              <label className="form-label small text-secondary">Who are you?</label>
              <select
                className="form-select"
                value={username}
                onChange={(e) => setUsername(e.target.value as Username)}
              >
                {USERS.map((u) => (
                  <option key={u.value} value={u.value}>
                    {u.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label small text-secondary">Password</label>
              <input
                className="form-control"
                type="password"
                value={password}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={login.isPending || password.length === 0}
            >
              {login.isPending ? 'Signing in…' : 'Sign in'}
            </button>
            {login.isError && (
              <p className="text-danger small mt-3 mb-0 text-center">
                {errorMessage(login.error.code)}
              </p>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}
